import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { cn } from '@/lib/cn';
const sizeClasses = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-lg',
    lg: 'sm:max-w-2xl',
    xl: 'sm:max-w-5xl',
};
export function Modal({ open, onClose, title, children, size = 'md' }) {
    useEffect(() => {
        if (!open)
            return;
        function handleKey(e) {
            if (e.key === 'Escape')
                onClose();
        }
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open, onClose]);
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
    if (!open)
        return null;
    return createPortal(_jsxs("div", { className: "fixed inset-0 z-50 flex items-center justify-center p-0 sm:p-4", children: [_jsx("div", { className: "absolute inset-0 bg-black/50 backdrop-blur-sm", onClick: onClose, "aria-hidden": "true" }), _jsxs("div", { role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-title", className: cn('relative flex w-full flex-col bg-white shadow-xl dark:bg-gray-900', 'border border-gray-200 dark:border-gray-700', 
                // Full-screen en móvil, tarjeta centrada desde sm
                'h-full max-h-full rounded-none sm:h-auto sm:max-h-[90vh] sm:rounded-2xl', sizeClasses[size]), children: [_jsxs("div", { className: "flex shrink-0 items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-700", children: [_jsx("h2", { id: "modal-title", className: "text-base font-semibold text-gray-900 dark:text-gray-100", children: title }), _jsx("button", { onClick: onClose, className: "rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-300", "aria-label": "Cerrar", children: _jsxs("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, className: "h-5 w-5", children: [_jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), _jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })] }) })] }), _jsx("div", { className: "min-h-0 flex-1 overflow-y-auto p-4 sm:p-6", children: children })] })] }), document.body);
}
//# sourceMappingURL=Modal.js.map